import React from 'react';
import moment from 'moment';
import { Table } from '../../../common-components/Table/Table';
import { If } from '../../../common-components/If/If';
import { ErpOrder } from '../../../models/ErpOrder';
import { Order } from '../../../models/Order';
import { OrderNote } from '../../../models/OrderNote';
import { strings } from '../../../resources/strings';
import { Container, GroupInformation, NoteHeader, NoteSource, NoteDate, NoteValue } from './styles';

interface ITabOtherInformationsProps {
    order?: Order|null;
    erpOrder?: ErpOrder|null;
    orderNotes?: OrderNote[];
}

type NoteItem = {
    source?: string;
    formattedDate: string;
    value: string;
}

export const TabOtherInformations: React.FC<ITabOtherInformationsProps> = ({
    order,
    erpOrder,
    orderNotes
}) => {

    const notes = React.useMemo(() => {
        const items: NoteItem[] = [];
        
        if (order?.note) {
            items.push({
                source: 'Shopify',
                formattedDate: '',
                value: order.note
            });
        }

        if (orderNotes && orderNotes.length > 0) {
            items.push(...orderNotes.map(orderNote => {
                return {
                    source: orderNote.createdBy?.name,
                    formattedDate: moment(orderNote.createdAt).format('DD/MM/yyyy HH:mm:ss'),
                    value: orderNote.value
                };
            }));
        }

        return (
            <Table>
                <thead>
                    <tr>
                        <th>{strings.Notes}</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, itemIndex) => {
                        return (
                            <tr key={`note-item-${itemIndex}`}>
                                <td>
                                    <NoteHeader>
                                        <If condition={!!item.formattedDate}>
                                            <NoteDate>{item.formattedDate}</NoteDate>
                                        </If>
                                        <NoteSource>{item.source}</NoteSource>
                                    </NoteHeader>
                                    <NoteValue>
                                        {item.value}
                                    </NoteValue>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }, [ order, orderNotes ]);

    const vendorAndLocation = React.useMemo(() => {
        return (
            <Table>
                <thead>
                    <tr>
                        <th style={{width:'50%'}}>{strings.Shop}</th>
                        <th style={{width:'50%'}}>{strings.Vendor}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{order?.location?.name}</td>
                        <td>{order?.seller?.name}</td>
                    </tr>
                </tbody>
            </Table>
        );
    }, [ order, erpOrder ]);

    return (
        <Container>
            <GroupInformation>
                {vendorAndLocation}
            </GroupInformation>
            <GroupInformation>
                {notes}
            </GroupInformation>
        </Container>
    );
};